import { toast } from '@approvalmax/ui/src/components';
import { hooks } from '@approvalmax/utils';
import { useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSendResetPasswordTFAEmailCode, useVerifyResetPasswordTFACode } from 'shared/data/webApp/v1';
import { getPath, Path } from 'urlBuilder';

import { messages } from './Content.messages';
import { ContentProps } from './Content.types';

export const useTwoFa = (props: Pick<ContentProps['startData'], 'stateId' | 'requiresTFA'>) => {
    const { stateId, requiresTFA } = props;

    const history = useHistory();

    const [postAction] = hooks.useQueryParam('postAction');
    const [isTFAPassed, setIsTFAPassed] = useState(!requiresTFA);

    const { mutate: sendResetPasswordTFAEmailCode, isLoading: isLoadingSendResetPasswordTFAEmailCode } =
        useSendResetPasswordTFAEmailCode({
            onSuccess: () => {
                toast.success(messages.codeBeenSent);
            },
        });

    const { mutate: verifyResetPasswordTFACode, isLoading: isLoadingVerifyResetPasswordTFACode } =
        useVerifyResetPasswordTFACode({
            onSuccess: () => {
                setIsTFAPassed(true);
            },
        });

    const handleRequestCodeOnEmail = useCallback(() => {
        sendResetPasswordTFAEmailCode({ body: { stateId } });
    }, [sendResetPasswordTFAEmailCode, stateId]);

    const handleVerifyTFA = useCallback(
        (code: string) => {
            verifyResetPasswordTFACode({ body: { stateId, code } });
        },
        [stateId, verifyResetPasswordTFACode]
    );

    const handleCloseTFA = useCallback(() => {
        history.replace(getPath(Path.login, { redirectPath: postAction }));
    }, [history, postAction]);

    return {
        handleVerifyTFA,
        handleRequestCodeOnEmail,
        handleCloseTFA,
        isTFAPassed,
        isTFALoading: isLoadingSendResetPasswordTFAEmailCode || isLoadingVerifyResetPasswordTFACode,
    };
};
